import { createRouter, createWebHistory } from 'vue-router';
import FileManager from './views/FileManager.vue';
import Login from './components/Login.vue';
import Settings from './views/Settings.vue';

const routes = [
  { path: '/', name: 'Home', component: FileManager, meta: { requiresAuth: true } },
  { path: '/login', name: 'Login', component: Login, meta: { requiresAuth: false } },
  { path: '/settings', name: 'Settings', component: Settings, meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Función para verificar caducidad real del token (JWT)
function isTokenExpired(token) {
  if (!token) return true;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const { exp } = JSON.parse(jsonPayload);
    return exp < (Date.now() / 1000);
  } catch (e) { return true; }
}

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('accessToken'); // Usamos sessionStorage
  const isValidSession = token && !isTokenExpired(token);

  if (to.meta.requiresAuth && !isValidSession) {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    next({ name: 'Login' });
  } else if (to.name === 'Login' && isValidSession) {
    next({ name: 'Home' });
  } else {
    next();
  }
});

export default router;